import { z } from "zod";
//#region src/platform-manifest.schemas.ts
/**
* Zod schemas for `cloud/dp/platform.json` (DP version identity file).
*/
const PlatformComponentSchema = z.object({ package: z.string().min(1) }).strict();
const PlatformManifestSchema = z.object({
	version: z.string().min(1),
	minimumSdkVersion: z.string().min(1),
	components: z.record(z.string(), PlatformComponentSchema)
}).strict();
//#endregion
export { PlatformComponentSchema, PlatformManifestSchema };

//# sourceMappingURL=platform-manifest.schemas.js.map